/* XSD Cards theme script: cart drawer, AJAX add to cart, gallery, variant select, filters. */
(() => {
  const theme = window.theme || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.append(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2400);
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach((track) => {
    const msgs = $$('.announce__msg', track);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Close open <details> menus on outside click / Escape ---------- */
  document.addEventListener('click', (e) => {
    $$('.nav-dropdown[open], .facets__toggle[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.nav-dropdown[open], .facets__toggle[open], [data-menu-drawer][open]').forEach((d) => d.removeAttribute('open'));
    closeDrawer();
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  let lastFocus;
  function openDrawer() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    const close = $('[data-drawer-close].icon-btn', drawer);
    close && close.focus();
    return true;
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus();
  }
  if (drawer) {
    $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', closeDrawer));
    $$('[data-cart-toggle]').forEach((a) =>
      a.addEventListener('click', (e) => {
        if (openDrawer()) e.preventDefault();
      })
    );
  }

  async function refreshCart() {
    const root = theme.routes ? theme.routes.root_url : '/';
    const base = root.endsWith('/') ? root : root + '/';
    const targets = [['#CartDrawerBody'], ['#CartPageBody']];
    // Re-render through the cart page HTML so prices, badges and shipping bar stay server-rendered.
    try {
      const res = await fetch(`${base}cart?_=${Date.now()}`, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-contents]');
      if (fresh) {
        targets.forEach(([sel]) => {
          const el = $(sel);
          if (!el) return;
          const old = $('[data-cart-contents]', el);
          const clone = fresh.cloneNode(true);
          if (sel === '#CartDrawerBody') clone.querySelectorAll('.cart-note').forEach((n) => n.remove());
          old ? old.replaceWith(clone) : el.append(clone);
        });
      }
      const cart = await (await fetch(`${base}cart.js`, { credentials: 'same-origin' })).json();
      $$('[data-cart-count]').forEach((c) => {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });
    } catch (err) {
      console.error(err);
    }
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const errEl = form.querySelector('[data-form-error]');
    if (btn) btn.disabled = true;
    if (errEl) errEl.hidden = true;
    try {
      const res = await fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || theme.strings.error);
      if (theme.cartType === 'page' || !drawer) {
        window.location.href = theme.routes.cart_url;
        return;
      }
      await refreshCart();
      openDrawer();
      toast(theme.strings.added);
    } catch (err) {
      if (errEl) {
        errEl.textContent = err.message || theme.strings.error;
        errEl.hidden = false;
      } else {
        toast(err.message || theme.strings.error);
      }
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Cart quantity buttons (drawer + page) ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    await changeLine(b.dataset.qtyChange, parseInt(b.dataset.qty, 10));
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    await changeLine(input.dataset.qtyInput, Math.max(0, parseInt(input.value, 10) || 0));
  });
  async function changeLine(key, quantity) {
    const box = document.querySelector('[data-cart-contents]');
    box && box.classList.add('is-loading');
    try {
      const res = await fetch(theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
        credentials: 'same-origin'
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        toast(data.description || theme.strings.error);
      }
    } finally {
      await refreshCart();
    }
  }

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const show = (id) => {
      $$('.gallery__slide', g).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
      $$('[data-thumb]', g).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    g._show = show;
    $$('[data-thumb]', g).forEach((t) => t.addEventListener('click', () => show(t.dataset.thumb)));
  });

  /* ---------- Variant select ---------- */
  $$('[data-variant-select]').forEach((sel) => {
    const section = sel.closest('[data-product-section]');
    sel.addEventListener('change', () => {
      const opt = sel.selectedOptions[0];
      const priceBox = $('[data-price] .price', section);
      if (priceBox) {
        const now = $('.price__now', priceBox);
        if (now) now.textContent = opt.dataset.price;
        let was = $('.price__was', priceBox);
        if (opt.dataset.compare) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'price__was mono';
            priceBox.append(was);
          }
          was.textContent = opt.dataset.compare;
          priceBox.classList.add('price--sale');
        } else {
          was && was.remove();
          priceBox.classList.remove('price--sale');
        }
      }
      const btn = $('[data-add-button]', section);
      const available = opt.dataset.available === 'true';
      if (btn) {
        btn.disabled = !available;
        btn.textContent = available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      const g = $('[data-gallery]', section);
      if (g && g._show && opt.dataset.media) g._show(opt.dataset.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- Filters and sorting (swap results in place, no full reload) ---------- */
  let facetTimer;
  function applyFacets(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
    const url = `${form.action}?${params.toString()}`;
    const results = $('[data-results]');
    if (!results) return (window.location.href = url);
    results.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-results]');
        if (!fresh) throw new Error('no results');
        const wasOpen = !!$('.facets__toggle[open]', results);
        results.replaceWith(fresh);
        if (wasOpen) {
          const tog = $('.facets__toggle', fresh);
          tog && tog.setAttribute('open', '');
        }
        window.history.replaceState({}, '', url);
      })
      .catch(() => (window.location.href = url));
  }
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-facets-form] [data-facet-input]')) return;
    const form = e.target.closest('form');
    clearTimeout(facetTimer);
    facetTimer = setTimeout(() => applyFacets(form), e.target.type === 'number' ? 500 : 0);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    applyFacets(form);
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (box) => {
    if (box.children.length) return;
    try {
      const html = await (await fetch(box.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
    } catch (e) {
      /* recommendations are optional */
    }
  });

  /* ---------- Login: toggle password recovery ---------- */
  $$('[data-toggle-recover]').forEach((a) =>
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const r = $('#RecoverForm');
      const l = $('#LoginForm');
      if (!r || !l) return;
      r.hidden = !r.hidden;
      l.hidden = !r.hidden;
    })
  );
  if (window.location.hash === '#recover') {
    const r = $('#RecoverForm');
    const l = $('#LoginForm');
    if (r && l) { r.hidden = false; l.hidden = true; }
  }
})();
